import { FC, ReactNode, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import OAuthContext from './OAuthContext';
import { useAuthenticateUser } from 'lib/qffAuth/oauth';
import useOAuthLogin from './hooks/useOAuthLogin';
import useOAuthLogout from './hooks/useOAuthLogout';
import getMemberIdFromLslCookies from 'utils/getMemberIdFromLslCookies';
import { QLFF_WL_SESS } from 'config/constants';
import jscookie from 'js-cookie';

interface Props {
  children: ReactNode;
}

const OAuthProvider: FC<Props> = ({ children }) => {
  const { login } = useOAuthLogin();
  const { logout } = useOAuthLogout();
  const { pathname } = useLocation();
  const authenticateUser = useAuthenticateUser();

  useEffect(() => {
    const memberId = getMemberIdFromLslCookies();

    if (pathname.startsWith('/auth') || !memberId) {
      return;
    }

    authenticateUser({ variables: { memberId } });
  }, [pathname, authenticateUser]);

  useEffect(() => {
    const memberId = getMemberIdFromLslCookies();

    if (pathname.startsWith('/auth')) {
      return;
    }

    if (!memberId && jscookie.get(QLFF_WL_SESS)) {
      login({
        noPrompt: true,
      });
    }
  }, [login, pathname]);

  const value = useMemo(
    () => ({
      login,
      logout,
    }),
    [login, logout],
  );

  return <OAuthContext.Provider value={value}>{children}</OAuthContext.Provider>;
};

export default OAuthProvider;
